import React from 'react';
import { Container, Fade, styled } from '@mui/material';

import { EXACARE_LOGO_URLS } from '@/constants';

interface LoadingScreenProps {
  animate?: boolean;
  fade?: boolean;
}

const LOADING_LOGO_SCALE_FACTOR = 0.7;

const StyledHeartImage = styled('img', {
  shouldForwardProp: (prop) => prop !== 'animate'
})<LoadingScreenProps>((props) => ({
  width: 60 * LOADING_LOGO_SCALE_FACTOR,
  [props.theme.breakpoints.up('sm')]: {
    width: 80 * LOADING_LOGO_SCALE_FACTOR
  },
  [props.theme.breakpoints.up('md')]: {
    width: 100 * LOADING_LOGO_SCALE_FACTOR
  },
  animation: props.animate ? 'heartbeat 1.5s ease-in-out infinite' : 'none',
  '@keyframes heartbeat': {
    '0%': {
      transform: 'scale(1)'
    },
    '14%': {
      transform: 'scale(1.15)'
    },
    '28%': {
      transform: 'scale(1)'
    },
    '42%': {
      transform: 'scale(1.15)'
    },
    '70%': {
      transform: 'scale(1)'
    }
  }
}));

const StyledTextImage = styled('img')(({ theme }) => ({
  width: 300 * LOADING_LOGO_SCALE_FACTOR,
  [theme.breakpoints.up('sm')]: {
    width: 400 * LOADING_LOGO_SCALE_FACTOR
  },
  [theme.breakpoints.up('md')]: {
    width: 500 * LOADING_LOGO_SCALE_FACTOR
  }
}));

const LogoContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 20,
  [theme.breakpoints.up('sm')]: {
    gap: 26.75
  },
  [theme.breakpoints.up('md')]: {
    gap: 33.5
  }
}));

const LoadingScreen: React.FC<LoadingScreenProps> = ({
  animate = false,
  fade = false
}) => {
  const content = (
    <LogoContainer>
      <StyledHeartImage src={EXACARE_LOGO_URLS.heart} animate={animate} />
      <StyledTextImage src={EXACARE_LOGO_URLS.text} />
    </LogoContainer>
  );

  return (
    <Container
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {fade ? (
        <Fade in={fade} timeout={{ enter: 1000 }}>
          {content}
        </Fade>
      ) : (
        content
      )}
    </Container>
  );
};

export default LoadingScreen;
